import potentialCalamityReportService from "../api/server/potentialCalamityReportService";
export const POTENTIAL_CALAMITY_REPORT_NAMESPACE =
  "potentialCalamityReportModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/potentialCalamityReportService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(potentialCalamityReportService)
};

const state = {
  loading: false,
  potentialCalamities: [],
  selectedPotential: {},
  filterOnTimeZones: [],
  filterOnClients: [],
  sendingTrackRequest: false,
  sortedTransitState: [],
  sortedTransitStatus: [],
  selectedPotentialPackages: [],
  transitCodes: {
    TransitState: [
      { key: "In Transit", class: "InTransitState", sortNum: 1 },
      { key: "At Sort", class: "AtSortState", sortNum: 2 },
      { key: "At Destination", class: "AtDestinationState", sortNum: 3 },
      { key: "Out For Delivery", class: "OutForDeliveryState", sortNum: 4 },
      { key: "Delivered", class: "DeliveredState", sortNum: 5 },
      { key: "Manifested", class: "ManifestedState", sortNum: 6 },
      { key: "", class: "OtherState", sortNum: 999 }
    ],
    TransitStatus: [
      { key: "Exception", class: "ExceptionStatus", sortNum: 1 },
      { key: "At Origin", class: "AtOriginStatus", sortNum: 2 },
      { key: "Arrived", class: "InTransitArrivedStatus", sortNum: 3 },
      { key: "Departed", class: "InTransitDepartedStatus", sortNum: 4 },
      { key: "At Destination", class: "AtDestinationMetroStatus", sortNum: 5 },
      { key: "", class: "OtherStatus", sortNum: 999 }
    ]
  }
};
const actions = {
  async CREATE(context, data) {
    var api = await services.api;
    return api.create(data).then(function(value) {
      context.commit("RESET");
    });
  },
  SELECT_ALL(context, data) {
    return context.commit("SET_ALL_SELECTED", data);
  },
  CLEAR_ALL(context, data) {
    context.commit("CLEAR_SELECTED", data);
  },
  async LOAD_POTENTIAL(context) {
    context.commit("RESET_POTENTIAL");
    state.loading = true;
    var api = await services.api;
    return api.loadPotential().then(function(value) {
      context.commit("SET_POTENTIAL", value);
      state.loading = false;
    });
  },
  FILTER_BY_CLIENT(context, value) {
    context.commit("SET_CLIENT_FILTER", value);
  },

  FILTER_BY_TIMEZONE(context, value) {
    context.commit("SET_TIMEZONE_FILTER", value);
  },
  SELECT_POTENTIAL(context, value) {
    context.commit("SET_SELECTED_POTENTIAL", value);
  },
  async LOAD_POTENTIAL_PACKAGES(context, value) {
    state.loading = true;
    var api = await services.api;
    return api.loadPotentialPackages(value).then(function(value) {
      context.commit("SET_POTENTIAL_PACKAGES", value);
      state.loading = false;
    });
  },
  async LOAD_SELECTED_POTENTIAL(context, hashKey) {
    var api = await services.api;
    return api.loadSelectedPotential(hashKey).then(function(res) {
      /* istanbul ignore else */
      if (res.length === 1) {
        state.selectedPotential = res[0];
        return api
          .loadPotentialPackages(state.selectedPotential.HashKey)
          .then(function(value) {
            context.commit("SET_POTENTIAL_PACKAGES", value);
          });
      }
    });
  },
  async SendTrackRequest(context, packages) {
    state.sendingTrackRequest = true;
    var api = await services.api;
    return api.SendTrackRequest(packages).then(function(value) {
      state.sendingTrackRequest = false;
    });
  }
};

const mutations = {
  RESET_POTENTIAL(storeState) {
    storeState.potentialCalamities = [];
  },
  SET_POTENTIAL(storeState, data) {
    storeState.potentialCalamities = data;
  },
  SET_TIMEZONE_FILTER(storeState, data) {
    storeState.filterOnTimeZones = data;
  },
  SET_CLIENT_FILTER(storeState, data) {
    storeState.filterOnClients = data;
  },
  SET_SELECTED_POTENTIAL(storeState, data) {
    storeState.selectedPotential = storeState.potentialCalamities.find(
      x => x.HashKey === data.id
    );
  },
  SET_POTENTIAL_PACKAGES(storeState, data) {
    data.forEach(function(item) {
      item.selected = false;
    });
    storeState.selectedPotentialPackages = data;
    storeState.sortedTransitStatus = helpers.sortTransit(
      "TransitStatus",
      _.cloneDeep(data)
    );
    storeState.sortedTransitState = helpers.sortTransit(
      "TransitState",
      _.cloneDeep(data)
    );
    storeState.loading = false;
  },
  SET_ALL_SELECTED(storeState, data) {
    if (data.filterKey === "") {
      storeState.selectedPotentialPackages.forEach(function(item) {
        item.selected = true;
      });
    } else {
      storeState.selectedPotentialPackages
        .filter(
          // eslint-disable-next-line
          x => data.filter[data.filterKey][x[data.filterKey]] === true
        )
        .forEach(function(item) {
          item.selected = true;
        });
    }
  },
  CLEAR_SELECTED(storeState, data) {
    if (data.filterKey === "") {
      storeState.selectedPotentialPackages.forEach(function(item) {
        item.selected = false;
      });
    } else {
      storeState.selectedPotentialPackages
        .filter(
          // eslint-disable-next-line
          x => data.filter[data.filterKey][x[data.filterKey]] === true
        )
        .forEach(function(item) {
          item.selected = false;
        });
    }
  },
  RESET(storeState, data) {
    storeState.loading = false;
    storeState.potentialCalamities = [];
    storeState.selectedPotential = {};
    storeState.selectedPotentialPackages = [];
  }
};

const helpers = {
  sortTransit(type, data) {
    return data.sort(function(a, b) {
      let aNum = 999;
      let bNum = 999;
      let aObj = state.transitCodes[type].find(x => a[type] === x.key);
      /* istanbul ignore else */
      if (aObj) aNum = aObj.sortNum;
      let bObj = state.transitCodes[type].find(x => b[type] === x.key);
      /* istanbul ignore else */
      if (bObj) bNum = bObj.sortNum;

      return aNum - bNum;
    });
  }
};

const getters = {
  loading: storeState => storeState.loading,
  potentialCalamities: storeState => storeState.potentialCalamities,
  filteredList: storeState => {
    let filtered = storeState.potentialCalamities;

    if (storeState.filterOnClients && storeState.filterOnClients.length > 0) {
      filtered = filtered.filter(x =>
        storeState.filterOnClients.includes(x.Client)
      );
    }
    if (
      storeState.filterOnTimeZones &&
      storeState.filterOnTimeZones.length > 0
    ) {
      filtered = filtered.filter(x =>
        storeState.filterOnTimeZones.includes(x.TimeZone)
      );
    }

    return filtered;
  },
  sendingTrackRequest: storeState => storeState.sendingTrackRequest,
  selectedPotentialPackages: storeState => storeState.selectedPotentialPackages,
  sortedTransitState: storeState => storeState.sortedTransitState,
  sortedTransitStatus: storeState => storeState.sortedTransitStatus,
  selectedPotential: storeState => storeState.selectedPotential,
  transitCodes: storeState => storeState.transitCodes
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
